import React from "react";
import PropTypes from "prop-types";
import { mainStatusText } from "../views/Job/Job.messages";
import moment from "moment";
import { injectIntl } from "react-intl";

const StatusBadge = (props) => {
    const lng = props.intl.formatMessage;
    const dateNow = moment(new Date()).format('YYYY-MM-DD');

    /*
    * Form type and text for badge
    * */
    const resolveTypeAndStatus = () => {
        let badgeType;
        let statusText;
        switch (props.statusCode) {
            case 0:
                // If dueDate is due show status 'late'
                if (props.dueDate !== undefined && props.dueDate < dateNow) {
                    badgeType = 'status-late';
                    statusText = lng(mainStatusText.late);
                } else {
                    badgeType = 'status-invoice';
                    statusText = lng(mainStatusText.invoice);
                }
                break;
            case 1:
                badgeType = 'status-reminder';
                statusText = lng(mainStatusText.reminder);
                break;
            case 2:
                badgeType = 'status-collection';
                statusText = lng(mainStatusText.collection);
                break;
            case 101:
                badgeType = 'status-paid';
                statusText = lng(mainStatusText.paid);
                break;
            case 122:
                badgeType = 'status-processing';
                statusText = lng(mainStatusText.processing);
                break;
            default:
                badgeType = '';
                statusText = '';
                break;
        }
        return { badgeType, statusText };
    }

    const { badgeType, statusText } = resolveTypeAndStatus();

    if (statusText === '') {
        return null;
    }

    return (
        <div className={'badge ' + badgeType}>
            <span>{statusText}</span>
        </div>
    );
};

StatusBadge.propTypes = {
    intl: PropTypes.object.isRequired,
    statusCode: PropTypes.number,
    dueDate: PropTypes.string,
};

export default injectIntl(StatusBadge);